<div class="notification-action file-annotations-start">
  <div class="event-item">
    <span class="notification-activity date">{{notification.created | date:'dd MMM yyyy'}}</span>
    <div class="header-notification">
      <h3><span>Preparing file</span></h3>
    </div>
    <p>Your file will download shortly, we are preparing it for download.</p>
  </div>
</div>